import { React, useState, useContext, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { LocationLib } from "@cisco/spaces-dash-lib-lh2";
import { LocationTree } from "@cisco/spaces-dash-app-lh2";
import { useNotification } from "@cisco/spaces-dash-app-business-hierarchy";
import moment from "moment";
import { Flex, Card, Heading, Text, MTag, Modal, Button, Dropdown, MRadio, Plus, DotsThree, Checkbox, X } from "@cisco/spaces-dash-lib-styleguide";
import { AppContext } from "../../contexts/AppContext";
import * as PartnerHomeService from "../../service/partner-dashboard-service";
import { PropertiesContext } from "../../contexts/propertiesContext";
import "./partner-home.scss";
import ListBase from "../list-base/list-base";
import ManageApp from "../manage-app/manage-app";

function PartnerHome(props) {
  const { isPartnerDashboard: isPartnerDashboardProp, i18n, selectStep, activationCount, activationMap, partnerFirstOnBoardMessage, setPartnerFirstOnBoardMessage, setUserOnboardStatus } = props;
  const userData = useSelector((state) => state.userData);
  const { setToastMessage } = useNotification();
  const [isPartnerDashboard, setIsPartnerDashboard] = useState(false);
  const [isLicenseModalOpen, setIsLicenseModalOpen] = useState(false);
  const [showCreate, setShowCreate] = useState(false);
  const [appAction, setAppAction] = useState({});
  const [showManageAppModal, setShowManageAppModal] = useState(false);
  const [hideListApps, setHideListApps] = useState(false);
  const [selectedAppType, setSelectedAppType] = useState("");
  const { properties } = useContext(PropertiesContext);
  const [isReadWriteUser, setIsReadWriteUser] = useState(false);
  const [donotShowOnBoardMessage, setDonotShowOnBoardMessage] = useState(false);
  const [mtcAppAllowed, setMtcAppAllowed] = useState(true);
  const [userStatus] = useState({
    tenantId: sessionStorage.getItem("tenantId"),
    userName: sessionStorage.getItem("userName")
  });
  const navigate = useNavigate();
  const [showHome] = useState(true);
  const [partnerLicenseInfo, setPartnerLicenseInfo] = useState(null);
  const [acceptedOn, setAcceptedOn] = useState(null);
  const [licenseAgreement, setLicenseAgreement] = useState("");

  const appContextValue = useMemo(() => ({ isPartnerDashboard }), [isPartnerDashboard]);

  const navigateToAppActivationSandbox = () => {
    navigate(`/partner/sandbox/home`);
  };

  const clickApiDocumentation = () => {
    window.open(properties?.apiDocumentationLink, "_blank");
  };

  const cancelLicenseModal = () => {
    setIsLicenseModalOpen(false);
  };

  const openLicenseModal = () => {
    setIsLicenseModalOpen(true);
  };

  const cancelCreateModal = () => {
    setShowCreate(false);
  };

  const openCreateModal = () => {
    setShowCreate(true);
  };

  const navigateToDevNet = (navigateOption) => {
    const defaultUrl = "https://developer.cisco.com/cisco-spaces/";
    const url = properties && properties[navigateOption] ? properties[navigateOption] : defaultUrl;
    window.open(url, "_blank");
  };

  const getLicenseAcceptanceDetails = () => {
    const setup = properties.partnerDomainSetup ? properties.partnerDomainSetup : null;
    PartnerHomeService.getLicenseInfo(userStatus.tenantId, setup)
      .then((data) => {
        if (data.status && data.data && data.data.us && data.data.us.agreementStatus) {
          setPartnerLicenseInfo(data.data.us);
          if (data.data.us.acceptedOn) {
            const acceptedTime = new Date(data.data.us.acceptedOn);
            const date = moment(acceptedTime, "YYYY-MM-DD");
            let formattedDate = "NA";
            if (date.isValid()) {
              formattedDate = date.format("YYYY-MM-DD HH:mm:ss Z");
            }
            console.log(formattedDate);
            setAcceptedOn(formattedDate);
          }
        } else {
          setPartnerLicenseInfo(null);
          setAcceptedOn(null);
        }
      })
      .catch((error) => {
        setPartnerLicenseInfo(null);
        setAcceptedOn(null);
        console.error(`Partner Home: Error on getLicenseAcceptanceDetails${error}`);
      });
  };

  const endUserLicenseAgreement = () => {
    PartnerHomeService.getEndUserLicenseAgreement()
      .then((data) => {
        if (data.status && data.data && data.data.license) {
          setLicenseAgreement(data.data.license.replace(/\n/g, "<br />"));
        } else {
          setLicenseAgreement(i18n.t("partner-dashboard-app.auth.login.login-partner-base.license-agreement-unavailable-msg"));
        }
      })
      .catch((error) => {
        // setLicenseAgreement(tempData.replace(/\n/g, "<br />"));
        setLicenseAgreement(i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.license-agreement-unavailable-msg"));
        console.error(`Partner Home: Error on endUserLicenseAgreement${error}`);
      });
  };

  const editPartner = (app, stage, isView) => {
    console.log("Edit App in home", app, stage, isView);
    setAppAction({
      app,
      stage,
      action: isView ? "view" : "edit",
      type: app.applicationType
    });
    setShowManageAppModal(true);
  };

  const proceedToCreateApp = () => {
    console.log("proceedToCreateApp");
    if (selectedAppType !== "") {
      cancelCreateModal();
      setAppAction({
        app: {},
        stage: null,
        action: "create",
        type: selectedAppType
      });
      setShowManageAppModal(true);
    } else {
      cancelCreateModal();
      setAppAction({});
      setToastMessage(i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.select-app-type-before-app-creation-msg"), 4000, "negative");
    }
  };

  const createAppTypeSelection = (val) => {
    console.log("createAppTypeSelection", val);
    setSelectedAppType(val.target.value);
  };

  const clickToOnboardingDetails = (step) => {
    selectStep(step);
    navigate(`partner/onboarding/PartnerModel`);
  };

  const takeToOnboarding = () => {
    setPartnerFirstOnBoardMessage(false);
    sessionStorage.setItem("partnerOnboardingPopupShown", false);
    if (donotShowOnBoardMessage) {
      setUserOnboardStatus();
    }
    clickToOnboardingDetails(1);
  };

  const userOnBoardMessage = () => {
    return (
      <Modal size="xl" isOpen={partnerFirstOnBoardMessage}>
        <Flex align="left" direction="vertical" gap={16}>
          <Flex align="left" direction="vertical" gap={24}>
            <Flex align="left" direction="vertical" gap={8}>
              <Flex justify="space-between" style={{ width: "100%" }}>
                <Flex justify="left" style={{ width: "100%" }}>
                  <Heading size="primary">{i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.spaces-partner-onboarding-text")}</Heading>
                </Flex>
                <Flex justify="flex-end">
                  <X
                    style={{ cursor: "pointer" }}
                    size={20}
                    onClick={() => {
                      setPartnerFirstOnBoardMessage(false);
                      sessionStorage.setItem("partnerOnboardingPopupShown", false);
                    }}
                  />
                </Flex>
              </Flex>
              <Text align="left" color="light" size="p3">
                {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.spaces-partner-dashboard-info")}
              </Text>
              <Flex align="left" style={{ width: "100%" }}>
                <Checkbox onClick={() => setDonotShowOnBoardMessage((prev) => !prev)} checked={donotShowOnBoardMessage}>
                  <Text color="light" size="p3">
                    {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.do-not-show-again-text")}
                  </Text>
                </Checkbox>
              </Flex>
            </Flex>
            <Flex justify="flex-end" style={{ width: "100%" }}>
              <Button onClick={takeToOnboarding}>{i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.get-started-text")}</Button>
            </Flex>
          </Flex>
        </Flex>
      </Modal>
    );
  };

  const buildLicenseModal = () => {
    return (
      <Modal size="xl" isOpen={isLicenseModalOpen}>
        <Flex direction="vertical" id="license-modal">
          <Heading style={{ "margin-bottom": "10px" }}>{i18n.t("partner-dashboard-app.auth.login.login-partner-base.license-agreement")}</Heading>
        </Flex>
        <Modal.Content
          style={{
            marginBottom: 24,
            maxHeight: 500
          }}
        >
          <Flex direction="vertical" style={{ margin: "10px" }}>
            <Flex direction="vertical" justify="flex-start">
              <Flex>
                <Text compact ellipsis size="p3" weight="regular" color="light">
                  {`${i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.accepted-by-text")}: `}
                </Text>
                &nbsp;
                {partnerLicenseInfo && partnerLicenseInfo.acceptedBy && (
                  <Text id="license-accepted-by" compact ellipsis size="p3" weight="semi-bold">
                    {partnerLicenseInfo.acceptedBy}
                  </Text>
                )}
              </Flex>
              <Flex>
                <Text compact ellipsis size="p3" weight="regular" color="light">
                  {`${i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.accepted-on-text")}: `}
                </Text>
                &nbsp;
                <Text compact ellipsis size="p3" weight="semi-bold">
                  {acceptedOn}
                </Text>
              </Flex>
            </Flex>
            <Flex direction="vertical" justify="flex-start">
              <Text
                size="p3"
                weight="regular"
                color="light"
                style={{
                  "margin-top": "10px",
                  "margin-bottom": "10px",
                  "line-height": "25px"
                }}
              >
                <div dangerouslySetInnerHTML={{ __html: licenseAgreement }} />
              </Text>
            </Flex>
          </Flex>
        </Modal.Content>
        <Flex justify="flex-end" style={{ "margin-top": "10px" }}>
          <Button.Group>
            <Button kind="tertiary" onClick={cancelLicenseModal} id="license-modal-close">
              {i18n.t("partner-dashboard-app.auth.change-password.cancel-text")}
            </Button>
          </Button.Group>
        </Flex>
      </Modal>
    );
  };

  const rerenderList = () => {
    setHideListApps(true);
    setTimeout(() => {
      setHideListApps(false);
    }, 200);
  };

  const hideManageModal = () => {
    setShowManageAppModal(false);
    rerenderList();
  };

  const resetList = () => {
    rerenderList();
  };

  const manageAppContainer = () => {
    return appAction.action && <ManageApp action={appAction.action} type={appAction.type} app={appAction.app} hideManageModal={hideManageModal} />;
  };

  const copyAppFn = (app) => {
    console.log("Edit App in home", app);
    setAppAction({
      app,
      stage: null,
      action: "copy-create",
      type: app.applicationType
    });
    setShowManageAppModal(true);
  };

  const appCreateModal = () => {
    return (
      <Modal isOpen={showCreate}>
        <Flex direction="vertical" id="choose-app-type-modal">
          <Heading style={{ "margin-bottom": "10px" }}>{i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.choose-app-type-text")}</Heading>
        </Flex>
        <Modal.Content
          style={{
            marginBottom: 24,
            maxHeight: 500,
            borderTop: 0,
            borderBottom: 0
          }}
        >
          <Flex direction="vertical" style={{ margin: "40px 10px" }}>
            <MRadio
              direction="vertical"
              onChange={createAppTypeSelection}
              value={selectedAppType}
              options={[
                {
                  description: i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.multi-tenant-cloud-desc-text"),
                  key: 1,
                  disabled: !mtcAppAllowed,
                  label: i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.multi-tenant-cloud-text"),
                  value: "MTC"
                },
                {
                  description: i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.single-tenant-cloud-desc-text"),
                  key: 2,
                  label: i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.single-tenant-cloud-text"),
                  value: "STC"
                },
                {
                  description: i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.on-perm-desc-text"),
                  key: 3,
                  label: i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.on-prem-text"),
                  value: "On-Prem"
                }
              ]}
              size="md"
            />
          </Flex>
        </Modal.Content>
        <Flex justify="flex-end">
          <Button.Group>
            <Button
              kind="tertiary"
              onClick={() => {
                cancelCreateModal();
              }}
            >
              Cancel
            </Button>
            <Button
              id="create-app-type-button"
              onClick={() => {
                proceedToCreateApp();
              }}
            >
              Create
            </Button>
          </Button.Group>
        </Flex>
      </Modal>
    );
  };

  // Only update read/write user and MTC app allowed when userData changes
  useEffect(() => {
    if (userData && userData.userCurrentStatus && userData.userCurrentStatus.data) {
      const { partnerPermissions, "disable-features": disableFeatures } = userData.userCurrentStatus.data;
      setIsReadWriteUser(partnerPermissions?.includes("PartnerDashboardReadWrite"));
      setMtcAppAllowed(!(disableFeatures?.dashboard?.length && disableFeatures.dashboard.includes("partner_mtc")));
    }
  }, [userData]);

  // Only fetch license details and agreement once on mount
  useEffect(() => {
    getLicenseAcceptanceDetails();
    endUserLicenseAgreement();
    // eslint-disable-next-line
  }, []);

  // Only set dashboard flag on prop change
  useEffect(() => {
    if (isPartnerDashboardProp) {
      setIsPartnerDashboard(true);
    }
    // eslint-disable-next-line
  }, [isPartnerDashboardProp]);

  // Only set i18n namespace on mount
  useEffect(() => {
    i18n.loadNamespaces("partners-home");
    i18n.setDefaultNamespace("partners-home");
    // eslint-disable-next-line
  }, []);

  return (
    showHome && (
      <AppContext.Provider value={appContextValue}>
        {partnerFirstOnBoardMessage == true && userOnBoardMessage()}
        {isLicenseModalOpen && buildLicenseModal()}
        {!showManageAppModal && showCreate && appCreateModal()}
        {showManageAppModal && manageAppContainer()}
        <LocationLib isPartnerDashboard={isPartnerDashboard} />
        <div style={{ visibility: "hidden", height: 0, width: 0, opacity: 0 }}>
          <LocationTree params={{ type: "single", appName: "pd-home" }} />
        </div>
        <Flex direction="vertical" style={{ background: "#F7F7F7" }}>
          <Flex direction="vertical" style={{ margin: "24px 0px 0px 24px" }} gap={4}>
            <Heading size="primary" id="partner-home-heading">
              {i18n.t("partner-dashboard-app.partner-apps.app-center.home-text")}
            </Heading>
            {activationCount > 0 && (
              <Text size="p3" color="light">
                {`Total activations - ${activationCount}`}
              </Text>
            )}
          </Flex>
          <Flex direction="vertical" style={{ margin: "24px 10px 96px 24px" }}>
            <Flex gap={12}>
              {properties?.partnerDomainSetup && properties?.partnerDomainSetup === "us" && (
                <Card
                  id="create-app-card"
                  onClick={openCreateModal}
                  onKeyDown={openCreateModal}
                  style={{
                    width: 400
                  }}
                  disabled={!isReadWriteUser}
                >
                  <Flex direction="vertical" gap={12}>
                    <Flex align="flex-start" direction="horizontal" justify="space-between">
                      <Flex direction="vertical" gap={2}>
                        <Heading size="sub-section">{i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.create-new-app-text")}</Heading>
                      </Flex>
                      <Button onClick={openCreateModal} icon={<Plus size={16} weight="bold" />} kind="tertiary">
                        Add
                      </Button>
                    </Flex>
                  </Flex>
                </Card>
              )}

              <Card
                id="app_activation_sandbox"
                onClick={navigateToAppActivationSandbox}
                onKeyDown={navigateToAppActivationSandbox}
                style={{
                  width: 400
                }}
              >
                <Flex direction="vertical" gap={12}>
                  <Flex align="flex-start" direction="horizontal" justify="space-between">
                    <Flex direction="vertical" gap={2}>
                      <Heading size="sub-section">{i18n.t("partner-dashboard-app.partner-apps.app-center.app-activation-sandbox")}</Heading>
                    </Flex>
                  </Flex>
                </Flex>
              </Card>
            </Flex>
            {!hideListApps && (
              <div>
                {!hideListApps && (
                  <ListBase
                    partnerDomainSetup={properties?.partnerDomainSetup}
                    activationMap={activationMap}
                    mtcAppAllowed={mtcAppAllowed}
                    i18n={i18n}
                    copyAppFn={copyAppFn}
                    appEdit={editPartner}
                    resetList={resetList}
                    setHideListApps={setHideListApps}
                  />
                )}
              </div>
            )}
            <Flex style={{ "margin-top": "24px" }}>
              <Heading size="section">{i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.build-learn-analyze-text")}</Heading>
            </Flex>
            <Flex style={{ "margin-top": "16px" }} direction="horizontal" wrap="true" justify="flex-start" gap={12}>
              <Card
                id="on-boarding-tile"
                accent="success"
                style={{
                  width: 400
                }}
              >
                <Flex direction="vertical" gap={12}>
                  <Flex align="flex-start" direction="horizontal" justify="space-between">
                    <Flex direction="vertical" gap={2}>
                      <Flex align="center" direction="horizontal" gap={8}>
                        <Heading size="sub-section"> {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.partner-onboarding-text")}</Heading>
                        <MTag.Colored size="sm" color={4}>
                          {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.onboard-text")}
                        </MTag.Colored>
                      </Flex>
                      <Text color="light" size="p3">
                        {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.partner-onboarding-process-text")}
                      </Text>
                    </Flex>
                    <Dropdown title={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.view-text")} icon={<DotsThree />} placement="right" kind="tertiary">
                      <Dropdown.Item
                        onClick={() => {
                          clickToOnboardingDetails(1);
                        }}
                        label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.overview-text")}
                      />
                      <Dropdown.Item
                        onClick={() => {
                          clickToOnboardingDetails(2);
                        }}
                        label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.app-activation-text")}
                      />
                      <Dropdown.Item
                        onClick={() => {
                          clickToOnboardingDetails(3);
                        }}
                        label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.partner-dashboard-text")}
                      />
                      <Dropdown.Item
                        onClick={() => {
                          clickToOnboardingDetails(4);
                        }}
                        label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.onboard-process-text")}
                      />
                      <Dropdown.Item
                        onClick={() => {
                          clickToOnboardingDetails(5);
                        }}
                        label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.iot-service-marketplace-text")}
                      />
                    </Dropdown>
                  </Flex>
                </Flex>
              </Card>

              <Card
                accent="warning"
                style={{
                  width: 400
                }}
                onClick={() => {
                  clickApiDocumentation();
                }}
              >
                <Flex direction="vertical" gap={12}>
                  <Flex align="flex-start" direction="horizontal" justify="space-between">
                    <Flex direction="vertical" gap={2}>
                      <Flex align="center" direction="horizontal" gap={8}>
                        <Heading size="sub-section"> {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.api-documentation-text")}</Heading>
                        <MTag.Colored size="sm" color={5}>
                          {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.build-text")}
                        </MTag.Colored>
                      </Flex>
                      <Text color="light" size="p3">
                        {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.preliminary-documentation-text")}
                      </Text>
                    </Flex>
                    {/* <Dropdown title={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.view-text")} icon={<DotsThree />} kind="tertiary" placement="right">
                      <Dropdown.Item
                        onClick={() => {
                          clickApiDocumentation();
                        }}
                        label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.view-text")}
                      />
                    </Dropdown> */}
                  </Flex>
                </Flex>
              </Card>

              <Card
                accent="default"
                style={{
                  width: 400
                }}
                onClick={() => {
                  openLicenseModal();
                }}
              >
                <Flex direction="vertical" gap={12}>
                  <Flex align="flex-start" direction="horizontal" justify="space-between">
                    <Flex direction="vertical" gap={2}>
                      <Flex align="center" direction="horizontal" gap={8}>
                        <Heading size="sub-section"> {i18n.t("partner-dashboard-app.auth.login.login-partner-base.license-agreement")}</Heading>
                        <MTag.Colored size="sm" color={1}>
                          {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.license-text")}
                        </MTag.Colored>
                      </Flex>
                      <Text color="light" size="p3">
                        {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.see-your-license-agreement-text")}
                      </Text>
                    </Flex>
                    {/* <Dropdown title={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.view-text")} icon={<DotsThree />} kind="tertiary" placement="right">
                       <Dropdown.Item
                        onClick={() => {
                          openLicenseModal();
                        }}
                        label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.view-text")}
                      />
                    </Dropdown> */}
                  </Flex>
                </Flex>
              </Card>

              <Card
                accent="default"
                style={{
                  width: 400
                }}
                onClick={() => {
                  navigateToDevNet("examples");
                }}
              >
                <Flex direction="vertical" gap={12} grow>
                  <Flex direction="vertical" gap={2}>
                    <Flex align="center" direction="horizontal" gap={8}>
                      <Heading size="sub-section"> {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.examples-text")}</Heading>
                      <MTag.Colored size="sm" color={1}>
                        {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.learn-text")}
                      </MTag.Colored>
                    </Flex>
                    <Text color="light" size="p3">
                      {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.coming-soon-api-usage-text")}
                    </Text>
                  </Flex>
                </Flex>
              </Card>
              <Card
                accent="default"
                style={{
                  width: 400
                }}
                onClick={() => {
                  navigateToDevNet("usecases");
                }}
              >
                <Flex direction="vertical" gap={12} grow>
                  <Flex direction="vertical" gap={2}>
                    <Flex align="center" direction="horizontal" gap={8}>
                      <Heading size="sub-section"> {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.usecases-text")}</Heading>
                      <MTag.Colored size="sm" color={1}>
                        {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.learn-text")}
                      </MTag.Colored>
                    </Flex>
                    <Text color="light" size="p3">
                      {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.coming-soon-usecase-text")}
                    </Text>
                  </Flex>
                </Flex>
              </Card>
              <Card
                accent="success"
                style={{
                  width: 400
                }}
                onClick={() => {
                  navigateToDevNet("bestpractices");
                }}
              >
                <Flex direction="vertical" gap={12} grow>
                  <Flex direction="vertical" gap={2}>
                    <Flex align="center" direction="horizontal" gap={8}>
                      <Heading size="sub-section"> {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.best-practices-text")}</Heading>
                      <MTag.Colored size="sm" color={4}>
                        {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.performance-text")}
                      </MTag.Colored>
                    </Flex>
                    <Text color="light" size="p3">
                      {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.coming-soon-improve-integration")}
                    </Text>
                  </Flex>
                </Flex>
              </Card>
            </Flex>
          </Flex>
        </Flex>
      </AppContext.Provider>
    )
  );
}

export default PartnerHome;
